export interface ABTestingState {
    enabled: boolean;
    optimizely: {
        optimizelyInitialized: boolean;
        listenersLoaded: boolean;
        bannerExperiments: {
            openDownloadAppBanner: boolean;
        };
    };
}

export const abTestingInitialState: ABTestingState = {
    enabled: false,
    optimizely: {
        optimizelyInitialized: false,
        listenersLoaded: false,
        bannerExperiments: {
            openDownloadAppBanner: false,
        },
    },
};
